import IconDog from '@/components/IconDog'
import IconRoom from '@/components/IconRoom'
import IconSpa from '@/components/IconSpa'
import IconSwim from '@/components/IconSwim/IconSwim'
import IconUltraLuxury from '@/components/IconUltraLuxury'
import IconAllowCellPhones from '@/components/IconAllowCellPhones'

export const LOCATION_PANEL_LINKS = [
  {
    name: 'United States',
    items: [
      {
        name: 'Florida',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/g3p7db91iwwqchap7yin'
      },
      {
        name: 'California',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/wmx9pyln1hxhqzc96bde'
      },
      {
        name: 'Arizona',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/xpi0zvhhiqr4271zqnkq'
      },
      {
        name: 'Colorado',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/uw9jfhdckedmpsqdncqb'
      },
      {
        name: 'Texas',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/d1lwtfrjjozuafz5gr9d'
      },
      {
        name: 'New England',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/q6rmk0ye6s1otyg868fu'
      }
    ],
    topLocations: [
      {
        name: 'United States',
        link: '/united-states/',
        locations: [
          {
            name: 'Arizona',
            link: '/arizona/'
          },
          {
            name: 'California',
            link: '/california/'
          },
          {
            name: 'Florida',
            link: '/florida/'
          },
          {
            name: 'Midwest',
            link: '/midwest/'
          },
          {
            name: 'Texas',
            link: '/texas/'
          },
          {
            name: 'Nevada',
            link: '/nevada/'
          },
          {
            name: 'Utah',
            link: '/utah/'
          },
          {
            name: 'Virginia',
            link: '/virginia/'
          },
          {
            name: 'Colorado',
            link: '/colorado/'
          },
          {
            name: 'New Jersey',
            link: '/new-jersey/'
          }
        ]
      }
    ]
  },
  {
    name: 'Worldwide',
    items: [
      {
        name: 'Bali',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/g3p7db91iwwqchap7yin'
      },
      {
        name: 'Thailand',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/wmx9pyln1hxhqzc96bde'
      },
      {
        name: 'Spain',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/xpi0zvhhiqr4271zqnkq'
      },
      {
        name: 'Switzerland',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/q6rmk0ye6s1otyg868fu'
      },
      {
        name: 'South Africa',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/uw9jfhdckedmpsqdncqb'
      }
    ],
    topLocations: [
      {
        name: 'Canada',
        link: '/canada/',
        locations: [
          {
            name: 'British Columbia',
            link: '/british-columbia/'
          },
          {
            name: 'Ontario',
            link: '/ontario/'
          },
          {
            name: 'Montreal',
            link: '/montreal/'
          },
          {
            name: 'Calgary',
            link: '/calgary/'
          }
        ]
      },
      {
        name: 'Australia',
        link: '/australia/',
        locations: [
          {
            name: 'Queensland',
            link: '/queensland/'
          },
          {
            name: 'Victoria',
            link: '/victoria/'
          },
          {
            name: 'New South Wales',
            link: '/new-south-wales/'
          },
          {
            name: 'Western Australia',
            link: '/western-australia/'
          }
        ]
      },
      {
        name: 'Latin America',
        link: '/latin-america/',
        locations: [
          {
            name: 'Costa Rica',
            link: '/costa-rica/'
          },
          {
            name: 'Panama',
            link: '/panama/'
          },
          {
            name: 'Mexico',
            link: '/mexico/'
          },
          {
            name: 'Ecuador',
            link: '/ecuador/'
          }
        ]
      },
      {
        name: 'Europe',
        link: '/europe/',
        locations: [
          {
            name: 'United Kingdom',
            link: '/united-kingdom/'
          },
          {
            name: 'Spain',
            link: '/spain/'
          },
          {
            name: 'Switzerland',
            link: '/switzerland/'
          },
          {
            name: 'Greece',
            link: '/greece/'
          }
        ]
      },
      {
        name: 'Africa',
        link: '/africa/',
        locations: [
          {
            name: 'Tunisia',
            link: '/tunisia/'
          },
          {
            name: 'South Africa',
            link: '/south-africa/'
          },
          {
            name: 'Johannesburg',
            link: '/johannesburg/'
          },
          {
            name: 'Cape Town',
            link: '/cape-town/'
          }
        ]
      },
      {
        name: 'Asia',
        link: '/asia/',
        locations: [
          {
            name: 'Bali',
            link: '/bali/'
          },
          {
            name: 'India',
            link: '/india/'
          },
          {
            name: 'Malaysia',
            link: '/malaysia/'
          },
          {
            name: 'Thailand',
            link: '/thailand/'
          }
        ]
      }
    ]
  },
  {
    name: 'Amenities and Settings',
    groups: ['Treatment Services'],
    items: [
      {
        name: 'Ultra-Luxury',
        link: '/luxury/',
        image: IconUltraLuxury
      },
      {
        name: 'Pet Friendly',
        link: '/amenities/pet-friendly/',
        image: IconDog
      },
      {
        name: 'Allows Cell Phones',
        link: '/amenities/allow-cell-phones/',
        image: IconAllowCellPhones
      },
      {
        name: 'Pool',
        link: '/amenities/pool/',
        image: IconSwim
      },
      {
        name: 'Private Rooms',
        link: '/amenities/private-rooms/',
        image: IconRoom
      },
      {
        name: 'Wellness',
        link: '/approach/wellness/',
        image: IconSpa
      }
    ],
    settings: [
      {
        name: 'Beach',
        link: '/setting/beach/'
      },
      {
        name: 'Mountain',
        link: '/setting/mountain/'
      },
      {
        name: 'Tropical',
        link: '/setting/tropical/'
      }
    ]
  },
  {
    name: 'Levels of Care',
    treatmentServices: [
      {
        name: 'Detox',
        link: '/care/detox/'
      },
      {
        name: 'Residential Rehab',
        link: '/united-states/'
      },
      {
        name: 'Sober Living',
        link: '/care/sober-living/'
      },
      {
        name: 'Outpatient',
        link: '/care/outpatient/'
      },
      {
        name: 'Intensive Outpatient',
        link: '/care/intensive-outpatient-program/'
      },
      {
        name: 'Virtual',
        link: '/care/virtual/'
      },
      {
        name: 'In-Home',
        link: '/care/in-home/'
      }
    ]
  },
  {
    name: 'Insurance',
    items: [
      {
        name: 'Aetna',
        link: '/insurance/aetna/'
      },
      {
        name: 'Anthem',
        link: '/insurance/anthem/'
      },
      {
        name: 'Carelon Behavioral Health',
        link: '/insurance/carelon-behavioral-health/'
      },
      {
        name: 'BlueCross BlueShield',
        link: '/insurance/bluecross-blueshield/'
      },
      {
        name: 'Bright Health',
        link: '/insurance/bright-health/'
      },
      {
        name: 'CareFirst',
        link: '/insurance/carefirst/'
      },
      {
        name: 'Cigna',
        link: '/insurance/cigna/'
      },
      {
        name: 'ComPsych',
        link: '/insurance/compsych/'
      },
      {
        name: 'GuideWell',
        link: '/insurance/guidewell/'
      },
      {
        name: 'HealthNet',
        link: '/insurance/healthnet/'
      },
      {
        name: 'HealthPartners',
        link: '/insurance/healthpartners/'
      },
      {
        name: 'Highmark',
        link: '/insurance/highmark/'
      },
      {
        name: 'Humana',
        link: '/insurance/humana/'
      },
      {
        name: 'Intermountain Healthcare',
        link: '/insurance/intermountain-healthcare/'
      },
      {
        name: 'ITU Funds',
        link: '/insurance/itu-funds/'
      },
      {
        name: 'Kaiser Permanente',
        link: '/insurance/kaiser-permanente/'
      },
      {
        name: 'Medicaid',
        link: '/insurance/medicaid/'
      },
      {
        name: 'Medicare',
        link: '/insurance/medicare/'
      },
      {
        name: 'MHN',
        link: '/insurance/mhn/'
      },
      {
        name: 'Optum',
        link: '/insurance/optum/'
      },
      {
        name: 'Oscar',
        link: '/insurance/oscar/'
      },
      {
        name: 'Tricare',
        link: '/insurance/tricare/'
      },
      {
        name: 'Tufts Health',
        link: '/insurance/tufts-health/'
      },
      {
        name: 'United Healthcare',
        link: '/insurance/united-healthcare/'
      }
    ]
  }
]

export const TREATMENT_PANEL_LINKS = [
  {
    name: 'Conditions',
    items: [
      {
        name: 'Anxiety',
        link: '/condition/anxiety/'
      },
      {
        name: 'Burnout & Stress',
        link: '/condition/stress/'
      },
      {
        name: 'Co-Occurring Disorders',
        link: '/condition/co-occurring-disorders/'
      },
      {
        name: 'Depression',
        link: '/condition/depression/'
      },
      {
        name: 'Eating Disorders',
        link: '/condition/eating-disorders/'
      },
      {
        name: 'Gambling',
        link: '/condition/gambling/'
      },
      {
        name: 'Trauma',
        link: '/condition/trauma/'
      },
      {
        name: 'Alcohol',
        link: '/condition/alcohol/'
      },
      {
        name: 'Addiction',
        link: '/united-states/'
      }
    ]
  },
  {
    name: 'Treatment Methods',
    groups: ['Treatment Approach', 'Therapies'],
    treatmentApproach: [
      {
        name: 'Evidence-Based',
        link: '/approach/evidence-based/'
      },
      {
        name: 'Holistic',
        link: '/approach/holistic/'
      },
      {
        name: 'Wellness',
        link: '/approach/wellness/'
      },
      {
        name: '12 Step',
        link: '/approach/twelve-step/'
      }
    ],
    therapies: [
      {
        name: 'Art Therapy',
        link: '/therapies/art-therapy/'
      },
      {
        name: 'EMDR',
        link: '/therapies/eye-movement-desensitization-and-reprocessing/'
      },
      {
        name: 'Equine Therapy',
        link: '/therapies/equine-therapy/'
      },
      {
        name: 'Mindfulness-Based Cognitive Therapy',
        link: '/therapies/mbct/'
      }
    ]
  },
  {
    name: 'Clientele',
    groups: ['Specialized Programs by Patient Population'],
    group1: [
      {
        name: 'Women',
        link: '/clientele/women/'
      },
      {
        name: 'Children',
        link: '/clientele/children/'
      },
      {
        name: 'Executives',
        link: '/clientele/executives/'
      },
      {
        name: 'Men',
        link: '/clientele/men/'
      },
      {
        name: 'Teens',
        link: '/clientele/adolescents/'
      },
      {
        name: 'Veterans',
        link: '/clientele/veterans/'
      },
      {
        name: 'LGBTQ+',
        link: '/clientele/lgbtq/'
      },
      {
        name: 'Young Adults',
        link: '/clientele/young-adults/'
      },
      {
        name: 'Christians',
        link: '/approach/christian/'
      },
      {
        name: 'Pregnant Women',
        link: '/clientele/pregnant-women/'
      },
      {
        name: 'Older Adults',
        link: '/clientele/older-adults/'
      },
      {
        name: 'Couples',
        link: '/clientele/couples/'
      }
    ]
  }
]

export const ABOUT_US_PANEL_LINKS = [
  {
    name: 'About Us',
    header: 'About Us',
    text: 'Recovery.com combines independent research with expert guidance on addiction and mental health treatment. Our mission is to help everyone find the best path to recovery through the most comprehensive, helpful network of treatment providers worldwide.',
    button: 'About Recovery.com',
    link: '/about/',
    header2: 'Advisory Board',
    text2:
      'Our advisory board brings together leaders in behavioral health, technology, and business. Their diverse expertise ensures our resources and product are innovative, evidence-based, and effective. They guide our mission as accomplished individuals dedicated to improving the landscape of addiction recovery and mental wellness.',
    button2: 'Meet Our Advisory Board',
    link2: '/advisory-board/'
  },
  {
    name: 'For Treatment Providers',
    header: "It's Free to Be on Recovery.com",
    text: 'Every month, 150,000 people search for addiction or mental health treatment on Recovery.com. Let us help them find you. ',
    button: 'Claim Your Profile Today',
    link: 'https://providers.recovery.com',
    header2: 'Edit Your Profile',
    text2:
      'Accurate, complete profiles best connect you with the right people for your services. Maintain your profile by updating your photos, video links, treatment services, and contact details to ensure optimal visibility. Our team will follow up with you after receiving your edits.',
    button2: 'Suggest Edits',
    link2: 'https://rehabpath.typeform.com/to/iuUtOK'
  },
  {
    name: 'Our Criteria',
    header: 'Our Criteria',
    text: 'We list any treatment center that meets our rehab criteria, giving you the best list of options possible when looking for treatment.',
    button: 'Our Criteria',
    link: '/criteria/',
    header2: 'Claim Your Profile',
    text2:
      'Recovery.com uses a standard procedure to make sure treatment provider profiles on our site are current and complete. We do this by <b>claiming</b> or <b>verifying</b> profiles.',
    button2: 'Learn More',
    link2: '/claim-verify-process/'
  },
  {
    name: 'Careers',
    header: 'Careers',
    text: 'Join our global mission of connecting patients with addiction and mental health treatment. See open positions and help people step into hope.',
    button: 'Careers',
    link: '/careers/'
  },
  {
    name: 'Contact Us',
    header: 'Contact Us',
    link: '/contact/',
    subheader1: 'For Providers',
    subheader2: 'For Treatment Seekers',
    text1:
      "If you're a treatment provider and have a question, please reach out and someone from our Customer Success team will be in touch with you shortly.",
    button: 'Contact Us',
    header2: 'For Treatment Seekers',
    text2:
      "If you're looking for treatment, please browse the site to reach out to treatment centers directly."
  },
  {
    name: 'Resource Hub',
    header: 'Resource Hub',
    text: 'Researched, fact-checked and transparent articles and guides that offer addiction and mental health insight from experts and treatment professionals.',
    button: 'Visit Our Resource Hub',
    link: '/resources/'
  }
]

export const LEARN_PANEL_LINKS = [
  {
    name: 'Resource Hub',
    header: 'Resource Hub',
    text: 'Researched, fact-checked and transparent articles and guides that offer addiction and mental health insight from experts and treatment professionals.',
    button: 'Visit Our Resource Hub',
    link: '/resources/'
  }
]

export const MOBILE_NAV_LINKS = [
  {
    label: 'United States',
    page: 'United States',
    container: 'United States'
  },
  {
    label: 'Worldwide',
    page: 'Worldwide',
    container: 'Worldwide'
  },
  {
    label: 'Amenities and Settings',
    page: 'Conditions',
    container: 'Amenities and Settings'
  }
]

export const ABOUT_NAV_LINKS = [
  {
    label: 'About Us',
    page: 'About',
    container: 'About Us',
    'aria-label': 'About Us'
  },
  {
    label: 'Our Criteria',
    page: 'About',
    container: 'Our Criteria'
  },
  {
    label: 'Careers',
    page: 'About',
    container: 'Careers'
  },
  {
    label: 'Contact Us',
    page: 'About',
    container: 'Contact Us'
  }
]
